import { PRODUCT_CONTENT_GET_SUCCESS } from '../actionTypes/ProductContentActionTypes';

function ProductContentReducer(state = [], action) {
    switch (action.type) {
        case PRODUCT_CONTENT_GET_SUCCESS:
            return action.productContent;
        default:
            return state;
    }
}

export default ProductContentReducer;
